import React, { useMemo } from 'react'

import { useSelector } from 'react-redux'

import { getRowTransferQuantity } from '../../redux/quantities/reducer'
import { getFilterValueByKey } from '../../redux/filters/reducer'

import * as S from './styles'

import StoreCell from '../StoreCell'

const StoreRow = ({ storeId, locationName, sizes, columns, first }) => {
  const rowDiff = useSelector(
    getRowTransferQuantity({ storeId, SKUs: columns.map(({ SKU }) => SKU) }),
  )
  const hideEmptyRows = useSelector(getFilterValueByKey('hideEmptyRows'))

  const isStoreEmpty = useMemo(() => {
    return (
      rowDiff === 0 &&
      sizes.reduce(
        (total, { quantityAvailable }) => total + quantityAvailable,
        0,
      ) === 0
    )
  }, [sizes, rowDiff])

  const rowTotal = sizes.reduce(
    (acc, { quantityAvailable }) => quantityAvailable + acc,
    0,
  )

  return hideEmptyRows && isStoreEmpty ? null : (
    <>
      <S.IDCell alert={isStoreEmpty}>{storeId}</S.IDCell>
      <S.BoldCell first={first} alert={isStoreEmpty}>
        {locationName}
      </S.BoldCell>
      {columns.map(({ name, id, internalId, SKU }) => {
        const cell = sizes.find(
          ({ value, SKU: sizeSKU }) => value === name || SKU === sizeSKU,
        )
        const { quantityAvailable, quantityOnOrder } = cell || {
          quantityAvailable: 0,
          quantityOnOrder: 0,
        }

        return (
          <StoreCell
            key={id || SKU}
            first={first}
            quantity={quantityAvailable}
            quantityOnOrder={quantityOnOrder}
            SKU={SKU}
            storeId={storeId}
            alert={isStoreEmpty}
            internalId={internalId}
          />
        )
      })}
      <S.BoldCell
        alert={isStoreEmpty}
        style={{ justifyContent: 'center', borderLeft: '1px solid #eee' }}
      >
        {rowTotal + rowDiff}
      </S.BoldCell>
    </>
  )
}

export default StoreRow
